
import axiosClient from "./axiosClient";


const storeService = {
  getListMedicineByParams: async (params) => {

    const url = `store/medicine/list-medicine/by-params`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListMedicineByQDThau: async (params) => {

    const url = `store/dau-thau/select/quyet-dinh-thau-thuoc`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  
  getListMedicineInStoreByParams: async (params) => {

    const url = `store/medicine-store/list-medicine`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getListLoInStoreByParams: async (params) => {

    const url = `store/medicine-store/list-lo`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },

  getListBaoChe: async () => {
    const url = `store/bao-che/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListDuocChinh: async () => {
    const url = `store/duoc-chinh/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListNguonThuoc: async () => {
    const url = `store/medicine-group/list-medicine-group`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getListPrescription1: async (params) => {
    const url = `store/prescription/search-key`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },

  getDetailPrescription: async (id) => {
    const url = `store/prescription/by-id`;
    const params = {
      id: id
    }
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },


  getListUnitByMedicineId: async (id) => {
    const url = `store/unit-conversion/by-thuoc-id?thuoc-id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  createAndPayPrescription: async (params) => {
    const url = `store/prescription/prescription-sales`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },

  getListPayments: async (params) => {
    const url = `store/payments/list-payments`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getListGoiThuoc: async (params) => {
    const url = `store/goi-thuoc/list-goi-thuoc`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  delGoiThuoc: async (params) => {
    const url = `store/goi-thuoc/delete`;
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  postGoiThuoc: async (params) => {
    const url = `store/goi-thuoc/create`;
    const response = await axiosClient.post(url, params)
    return response.data;
  }





















  // getMedicineList: async (params) => {
  //   const url = `store/medicine-store/list-medicine-store?page=1&limit=10`;
  //   const response = await axiosClient.get(url, {
  //     params: params,
  //   });
  //   return response;
  // },

  // /// Kho thuốc
  // getListMedicine: async (page, pageSize) => {
  //   const url = `store/medicine/list-medicine`;
  //   const params = {
  //     page: page,
  //     limit: pageSize
  //   }
  //   const response = await axiosClient.get(url, {
  //     params: params,
  //   });
  //   return response;
  // },

}

export default storeService;